import * as React from 'react'

import {
  ProductListSelectionProvider as SelectionProvider,
  useProductListDataCtx,
} from '~shared/segments/ProductList'

import { useMenuScreenLayout } from '../hooks/useMenuScreenLayout'

type TProps = RequiredChildren

/**
 * Combines all the providers needed to load, search in, filter, and render the product list.
 */
export const ProductListSelectionProvider: React.FC<TProps> = ({ children }) => {
  const productListContext = useProductListDataCtx()
  const { navigationAndCartStickyTopPx } = useMenuScreenLayout()

  return (
    <SelectionProvider
      dependencyData={productListContext}
      stuckContentHeight={navigationAndCartStickyTopPx}
    >
      {children}
    </SelectionProvider>
  )
}
